<template>
  <section class="community-podcast" v-if="podcasts && podcasts.length">
    <div class="container">
      <section-heading
        title="Community Podcast"
        to="PodcastList"
      ></section-heading>
      <div class="row mt-4" v-if="featuredPodcast">
        <div class="col-lg-12">
          <app-featured-episode
            :podcast="featuredPodcast"
            @click="onOpenPodcastDetails(featuredPodcast)"
          />
        </div>
      </div>
      <div class="row mt-5 podcast-items">
        <app-podcast-item-home
          v-for="podcast in podcasts.slice(1, 3)"
          :key="podcast.id"
          class="col-12 col-md-6"
          :podcast="podcast"
          @click="onOpenPodcastDetails(podcast)"
        />
      </div>
    </div>
  </section>
</template>

<script>
import SectionHeading from '@/components/general/SectionHeading.vue';
import AppPodcastItemHome from '@/components/home/Podcast';
import AppFeaturedEpisode from '@/components/podcast/FeaturedEpisode';

export default {
  components: { SectionHeading, AppPodcastItemHome, AppFeaturedEpisode },
  props: {
    podcasts: {
      type: Array,
      default() {
        return [];
      },
      required: true
    }
  },
  computed: {
    featuredPodcast() {
      return this.podcasts && this.podcasts.length ? this.podcasts[0] : null;
    }
  },
  methods: {
    onOpenPodcastDetails(podcast) {
      this.$router.push({ name: 'PodcastDetail', params: { id: podcast.id } });
    }
  }
};
</script>

<style lang="scss" scoped>
.community-podcast {
  padding: 60px 0;
  background: var(--cs-gray-00);
}
@media (min-width: 768px) {
  .podcast-items {
    margin-left: 0;
  }
}
</style>
